import {
  // ABTESTID_SUMMARIZER,
  // ABTEST_SUMMARIZER_COOKIE,
  // ABTESTID_TRANSLATIONOCR,
  ABTEST_TRANSLATIONOCR_COOKIE,
  ABTESTID_TRANSLATIONOCR_PROCESSIGNG,
  // ABTESTID_ANNOTATION_PROVIDER,
  // ABTEST_ANNOTATION_PROVIDER_COOKIE,
  // ABTEST_DESKTOP_PMNT_FUNNEL,
  // ABTEST_DESKTOP_PMNT_FUNNEL_COOKIE,
  // ABTEST_MOBILE_PMNT_FUNNEL,
  // ABTEST_MOBILE_PMNT_FUNNEL_COOKIE,
  DomainName,
  // ABTESTID_VWO_PAYMENT_FUNNEL,
  // ABTEST_VWO_PAYMENT_FUNNEL_COOKIE,
  // ABTESTID_VWO_PAYMENT_FUNNEL_MOBILE,
  // ABTEST_VWO_PAYMENT_FUNNEL_MOBILE_COOKIE,
  // ABTEST_APP_EDITOR,
  // ABTEST_APP_EDITOR_COOKIE,
  // ABTESTID_VWO_PAYMENT_CHECKOUT_COOKIE,
  // ABTESTID_VWO_PAYMENT_CHECKOUT,
  // ABTESTID_VWO_PS,
  // ABTESTID_VWO_PS_COOKIE,
  ABTEST_IMAGE_AI_GENERATION,
  ABTEST_IMAGE_AI_FUNNEL_COOKIE,
  ABTESTID_OPP_RESKIN,
  ABTEST_OPP_RESKIN_COOKIE,
  ABTEST_COMPARE_PDF_LP_US_ENG,
  ABTEST_COMPARE_PDF_LP_COOKIE,
  // ABTESTID_PDFSIMPLI_US_MOB_SANITIZEPDF,
  // ABTESTID_PDFSIMPLI_US_MOB_SANITIZEPDF_COOKIE,
  DASHBOARD_ABTESTID,
  DASHBOARD_ABTESTID_COOKIE,
  // ABTESTID_PDFSIMPLI_EDITOR,
  // ABTESTID_PDFSIMPLI_EDITOR_COOKIE,
} from "./constants";
import { readCookie, createCookie, handleAbTestDashboardFunnel } from "./helpers";
import { SwitchVisitorUserAbTest } from "../pages/sign-in/actions";
import { currentDomain } from "./general-config";

export const retrieveAbTestConfiguration = (abTestId, abTestCookieKey) => {
  let data = {
    abTestVariant: null,
    abTestId: null,
  };

  if (readCookie(abTestCookieKey)) {
    data = {
      abTestVariant: readCookie(abTestCookieKey),
      abTestId: abTestId,
    };
  }
  return data;
};

export const updateCookie = (abTestID, abTestVariant) => {
  const abTestCookieMap = {
    // [ABTESTID_SUMMARIZER]: ABTEST_SUMMARIZER_COOKIE,
    [ABTESTID_TRANSLATIONOCR_PROCESSIGNG]: ABTEST_TRANSLATIONOCR_COOKIE,
    // [ABTESTID_ANNOTATION_PROVIDER]: ABTEST_ANNOTATION_PROVIDER_COOKIE,
    // [ABTESTID_VWO_PAYMENT_FUNNEL]: ABTEST_VWO_PAYMENT_FUNNEL_COOKIE,
    // [ABTESTID_VWO_PAYMENT_FUNNEL_MOBILE]: ABTEST_VWO_PAYMENT_FUNNEL_MOBILE_COOKIE,
    // [ABTEST_APP_EDITOR]: ABTEST_APP_EDITOR_COOKIE,
    // [ABTESTID_VWO_PAYMENT_CHECKOUT]: ABTESTID_VWO_PAYMENT_CHECKOUT_COOKIE,
    [ABTEST_IMAGE_AI_GENERATION]: ABTEST_IMAGE_AI_FUNNEL_COOKIE,
    // [ABTESTID_PDFSIMPLI_EDITOR]: ABTESTID_PDFSIMPLI_EDITOR_COOKIE,
    [DASHBOARD_ABTESTID]: DASHBOARD_ABTESTID_COOKIE,
    // [ABTEST_COMPARE_PDF_LP_US_ENG]: ABTEST_COMPARE_PDF_LP_COOKIE,
  };

  const cookieName = abTestCookieMap[abTestID];
  if (cookieName) {
    createCookie(cookieName, abTestVariant);
  }
};
export const ConductABTest = (response, portalCDVal, validUserGuid) => {
  // check if ab test is conducted for summarizer
  // let isAbTestConducted = retrieveAbTestConfiguration(ABTESTID_SUMMARIZER, ABTEST_SUMMARIZER_COOKIE);
  // SwitchUserIdWithVisitorAbTest(isAbTestConducted, portalCDVal, validUserGuid);
  // check if ab test is conducted for translation OCR
  const abTestIds = [];
  // below code is only for English locale Flow for Desktop/Mobile
  let locale = localStorage.getItem("i18nextLng");
  if (!locale || locale.trim() === "") {
    locale = "en";
  }

  if (DomainName.PDFSIMPLI === currentDomain() && !(locale && locale !== "en")) {
    handleAbTestDashboardFunnel();
  }
  let isAbTestConductedForOcr = retrieveAbTestConfiguration(
    ABTESTID_TRANSLATIONOCR_PROCESSIGNG,
    ABTEST_TRANSLATIONOCR_COOKIE,
  );
  if (isAbTestConductedForOcr.abTestId) {
    abTestIds.push(isAbTestConductedForOcr.abTestId);
  }
  // check if ab test is conducted for Annotation Provider

  // let isAbTestConductedForAnnotationProvider = retrieveAbTestConfiguration(
  //   ABTESTID_ANNOTATION_PROVIDER,
  //   ABTEST_ANNOTATION_PROVIDER_COOKIE
  // );
  // SwitchUserIdWithVisitorAbTest(isAbTestConductedForAnnotationProvider, portalCDVal, validUserGuid);

  // // check if ab test is conducted for VWO Payment Funnel
  // let isAbTestConductedForVwoPaymentFunnel = retrieveAbTestConfiguration(
  //   ABTESTID_VWO_PAYMENT_FUNNEL,
  //   ABTEST_VWO_PAYMENT_FUNNEL_COOKIE
  // );
  // SwitchUserIdWithVisitorAbTest(isAbTestConductedForVwoPaymentFunnel, portalCDVal, validUserGuid);

  // checkout page abtest

  // let VwoPaymentCheckOutAbTest = retrieveAbTestConfiguration( ABTESTID_VWO_PAYMENT_CHECKOUT, ABTESTID_VWO_PAYMENT_CHECKOUT_COOKIE);
  // SwitchUserIdWithVisitorAbTest(VwoPaymentCheckOutAbTest, portalCDVal, validUserGuid);
  // // check if ab test is conducted for VWO Payment Funnel
  // let isAbTestConductedForVwoPaymentMobileFunnel = retrieveAbTestConfiguration(
  //   ABTESTID_VWO_PAYMENT_FUNNEL_MOBILE,
  //   ABTEST_VWO_PAYMENT_FUNNEL_MOBILE_COOKIE
  // );
  // SwitchUserIdWithVisitorAbTest(isAbTestConductedForVwoPaymentMobileFunnel, portalCDVal, validUserGuid);
  // check if ab test is conducted for App Editor ABTEST

  // let isAbTestConductedForAppEditor = retrieveAbTestConfiguration(ABTEST_APP_EDITOR, ABTEST_APP_EDITOR_COOKIE);

  // SwitchUserIdWithVisitorAbTest(isAbTestConductedForAppEditor, portalCDVal, validUserGuid);

  // check if ab test i conducted for Image AI Editor
  let isAbTestConductedForImageEditor = retrieveAbTestConfiguration(
    ABTEST_IMAGE_AI_GENERATION,
    ABTEST_IMAGE_AI_FUNNEL_COOKIE,
  );
  if (isAbTestConductedForImageEditor.abTestId) {
    abTestIds.push(isAbTestConductedForImageEditor.abTestId);
  }

  let isAbTestConductedForPdfLpUS = retrieveAbTestConfiguration(
    ABTEST_COMPARE_PDF_LP_US_ENG,
    ABTEST_COMPARE_PDF_LP_COOKIE,
  );
  if (isAbTestConductedForPdfLpUS.abTestId) {
    abTestIds.push(isAbTestConductedForPdfLpUS.abTestId);
  }
  // below code is only for English locale Flow for Desktop/Mobile
  // let locale = localStorage.getItem("i18nextLng");
  // if (!locale || locale.trim() === "") {
  //   locale = "en";
  // }

  // let domain = currentDomain()?.toLowerCase() || "";
  // if (locale.toLowerCase() === "en" && domain === DomainName.PDFSIMPLI.toLowerCase()) {
  //   //check for mobile device
  //   const isMobile = window.innerWidth < 768;
  //   let data = {
  //     AbTestId: isMobile ? ABTEST_MOBILE_PMNT_FUNNEL : ABTEST_DESKTOP_PMNT_FUNNEL,
  //     userGuid: validUserGuid,
  //     VisitorId: readCookie("visitorGuid"),
  //     portalCD: portalCDVal,
  //   };
  //   let isAbTestConductedForPaymentFunnel = isMobile ? readCookie("pyfnm_abval") : readCookie("pyfnd_abval");
  //   if (!isAbTestConductedForPaymentFunnel) {
  //     UserGuidABTestConduct(data).then((response) => {
  //       if (!!response && response.abTestVariant != null && response.abTestVariant !== 0) {
  //         console.log(`response ${isMobile ? "pyfnm_abval" : "pyfnd_abval"}`, response.abTestVariant);
  //         createCookie(
  //           isMobile ? ABTEST_MOBILE_PMNT_FUNNEL_COOKIE : ABTEST_DESKTOP_PMNT_FUNNEL_COOKIE,
  //           response.abTestVariant
  //         );
  //       }
  //     });
  //   }
  // }

  // let vwoCookieValueExist = readCookie("vwoCaseValue")
  // if(vwoCookieValueExist && domain === DomainName.PDFSIMPLI.toLowerCase()){
  //     let isAbTestConductedForVWOPS = retrieveAbTestConfiguration(ABTESTID_VWO_PS, ABTESTID_VWO_PS_COOKIE);
  // SwitchUserIdWithVisitorAbTest(isAbTestConductedForVWOPS, portalCDVal, validUserGuid);
  // }

  const oppeditabval = readCookie("oppeditabval");
  const validVariants = new Set(["1", "2"]);

  if (validVariants.has(oppeditabval)) {
    const isAbTestConductedForOPPEditor = retrieveAbTestConfiguration(ABTESTID_OPP_RESKIN, ABTEST_OPP_RESKIN_COOKIE);
    if (isAbTestConductedForOPPEditor.abTestId) {
      abTestIds.push(isAbTestConductedForOPPEditor.abTestId);
    }
  }

  // // ABTESTID_PDFSIMPLI_US_MOB_SANITIZEPDF
  // const mobabval = readCookie("mobabval");
  // const mobabvalvalidVariants = new Set(["1", "2"]);

  // if (mobabvalvalidVariants.has(mobabval)) {
  //   const isAbTestConductedForPdfSimpliUsMobSanitizepdf = retrieveAbTestConfiguration(
  //     ABTESTID_PDFSIMPLI_US_MOB_SANITIZEPDF,
  //     ABTESTID_PDFSIMPLI_US_MOB_SANITIZEPDF_COOKIE,
  //   );
  //   SwitchUserIdWithVisitorAbTest(isAbTestConductedForPdfSimpliUsMobSanitizepdf, portalCDVal, validUserGuid);
  // }

  // const pdfeditabval = readCookie("peditabval");
  // const peditabvalvalidVariants = new Set(["1", "2", "3"]);

  // if (peditabvalvalidVariants.has(pdfeditabval)) {
  //   const isAbTestConductedForPDFEditor = retrieveAbTestConfiguration(
  //     ABTESTID_PDFSIMPLI_EDITOR,
  //     ABTESTID_PDFSIMPLI_EDITOR_COOKIE,
  //   );
  //   SwitchUserIdWithVisitorAbTest(isAbTestConductedForPDFEditor, portalCDVal, validUserGuid);
  // }
  // }

  if (abTestIds.length > 0) {
    SwitchVisitorUserAbTest({
      AbTestIds: abTestIds,
      UserId: validUserGuid,
      VisitorId: readCookie("visitorGuid"),
      portalCD: portalCDVal,
    });
  }
};
